import React from 'react';
import clsx from 'clsx';

function formatNumber(styles, number, maxDecimals, minDecimals) {
  const formatter = new Intl.NumberFormat(navigator.language, {
    minimumIntegerDigits: 1,
    maximumFractionDigits: maxDecimals,
    minimumFractionDigits: minDecimals || maxDecimals,
  });

  const classNames = [styles.rightAlignText];
  let textValue = formatter.format(number);

  if (number < 0) {
    textValue = `(${formatter.format(number * -1)})`;
    classNames.push(styles.red);
  }

  return <span className={clsx(...classNames)}>{textValue}</span>;
}

export default formatNumber;
